import WaveAccessibilityTest from './WaveAccessibilityTest';
// import '../AccessibilityTest.css';

const AccessibilityTest = (props) => {
  const { wave_api_key, recaptcha_site_key } = props

  return (
    <div className="AccessibilityTest">
      <WaveAccessibilityTest wave_api_key={wave_api_key} recaptcha_site_key={recaptcha_site_key} />
    </div>
  );
}

export default AccessibilityTest;
